export default "__VITE_ASSET__DxbvaVya__"